import {Component, EventEmitter, Input, OnInit, Output,Injectable} from '@angular/core';
import {SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import Swal from "sweetalert2";
import {MaskPipe} from "ngx-mask";
import {MaskApplierService} from "ngx-mask";
import {LanguageService} from "../../modules/language/language.service";

@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss']
})

@Injectable({providedIn: 'root'})
export class PopupComponent implements OnInit {

    constructor(private maskApplierService: MaskApplierService,
                private languageService: LanguageService) {
    }

    ngOnInit() {

    }

    swalStyled = Swal.mixin({
        customClass: {
            container: 'popup',
            popup: 'popup__inner',
            image: 'popup__image',
            title: 'popup__title',
            content: 'popup__content',
            confirmButton: 'popup__btn popup__btn_confirm button',
            cancelButton: 'popup__btn popup__btn_cancel'},
    });

    showPopupSuccess(message?) {
        const langServiceSuccessMessage = this.languageService.getString('messagesData', 'successfulAction');
        const defaultSuccessMessage = langServiceSuccessMessage ? langServiceSuccessMessage : 'The action was successful!';

        const langServiceConfirmButtonText = this.languageService.getString('okThanks');
        const defaultConfirmButtonText = langServiceConfirmButtonText ? langServiceConfirmButtonText : 'OK, THANKS';
        this.swalStyled.fire({
            showClass: {
                popup: 'swal-success'
            },
            text: message.text ? message.text : defaultSuccessMessage,
            confirmButtonText: defaultConfirmButtonText,
        })
    }

    showPopupError(message?) {
        const langServiceErrorMessage = this.languageService.getString('messagesData', 'unknownError');
        const defaultErrorMessage = langServiceErrorMessage ? langServiceErrorMessage : 'Sorry there was an error try again later.';

        const langServiceConfirmButtonText = this.languageService.getString('back');
        const defaultConfirmButtonText = langServiceConfirmButtonText ? langServiceConfirmButtonText : 'BACK';

        let text = message && message.text ? message.text : defaultErrorMessage;
        let confirmButtonText = message && message.confirmButtonText ? message.confirmButtonText : defaultConfirmButtonText;
        let closeBtn = message && (message.closeBtn === false) ? message.closeBtn : true;

        this.swalStyled.fire({
            // title: 'Error',
            // imageUrl: '../assets/images/popup/error-logo.png',
            //className: "swal-back",
            showClass: {
                popup: 'swal-error'
            },
            text: text,
            showConfirmButton: closeBtn,
            allowOutsideClick: closeBtn,
            confirmButtonText: confirmButtonText
        })
    }

    showPopupAgreement(options, handler) {
        const langServiceErrorMessage = this.languageService.getString('messagesData', 'unknownError');
        const defaultErrorMessage = langServiceErrorMessage ? langServiceErrorMessage : 'Sorry there was an error try again later.';

        const langServiceConfirmButtonText = this.languageService.getString('confirm');
        const defaultConfirmButtonText = langServiceConfirmButtonText ? langServiceConfirmButtonText : 'CONFIRM';

        let text = options.text ? options.text : defaultErrorMessage;
        let confirmButtonText = options.confirmButtonText ? options.confirmButtonText : defaultConfirmButtonText;
        let cancelButtonText = options.cancelButtonText ? options.cancelButtonText : '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M25.5 24.1719L18.3281 17L25.5 9.82812C25.8668 9.46136 25.8668 8.86676 25.5 8.5C25.1332 8.13324 24.5386 8.13324 24.1719 8.5L17 15.6719L9.82813 8.5C9.46136 8.13324 8.86676 8.13324 8.5 8.5C8.13324 8.86676 8.13324 9.46136 8.5 9.82812L15.6719 17L8.5 24.1719C8.13324 24.5386 8.13324 25.1332 8.5 25.5C8.86676 25.8668 9.46136 25.8668 9.82813 25.5L17 18.3281L24.1719 25.5C24.5386 25.8668 25.1332 25.8668 25.5 25.5C25.8668 25.1332 25.8668 24.5386 25.5 24.1719Z" fill="#FDFD88"/>\n' +
            '</svg>';
        let showConfirmButton = options.showConfirmButton === false ? options.showConfirmButton : true;

        this.swalStyled.fire({
            showClass: {
                popup: 'swal-agreement',

            },
            html: text,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            showCancelButton: true,
            showConfirmButton: showConfirmButton,
        }).then((result) => {
            if (result.isConfirmed) {
                return handler(true);
            }else{
                return handler(false);
            }
        })
    }

    closePopup() {
        this.swalStyled.close();
    }

}
